<template>
    <div style="height:100%;">
        <div id="csContainer"></div>
    </div>
</template>

<script>
    import util from "../../components/util"

    export default {
        mounted() {
            this.init();
        },
        methods: {
            init() {
                let vw = util.getViewer("csContainer", {
                    terrainProvider: Cesium.createWorldTerrain(),
                    shouldAnimate: true
                });

                vw.camera.setView({
                    destination: new Cesium.Cartesian3(1216403.8845586285, -4736357.493351395, 4081299.715698949),
                    orientation: new Cesium.HeadingPitchRoll(4.2892217081808806, -0.4799070147502502, 6.279789177843313),
                    endTransform: Cesium.Matrix4.IDENTITY
                });
                this._groundRoaming(vw);
            },

            _groundRoaming(viewer) {
                let czml = [
                    {
                        "id": "document",
                        "version": "1.0",
                        "clock": {
                            "interval": "2018-07-19T15:18:00Z/2018-07-19T15:18:30Z",
                            "currentTime": "2018-07-19T15:18:00Z",
                            "multiplier": 5,
                            "range": "LOOP_STOP",
                            // "range": "CLAMPED",
                            "step": "SYSTEM_CLOCK_MULTIPLIER"
                        }
                    },
                    {
                        "id": "CesiumMilkTruck",
                        "model": {
                            "gltf": "/demo/static/data/models/car.glb",
                            "heightReference": "CLAMP_TO_GROUND"
                        },
                        "position": {
                            "interpolationAlgorithm": "LINEAR",
                            "forwardExtrapolationType": "HOLD",
                            "cartesian": [
                                "2018-07-19T15:18:00Z",
                                1216348.1632364073,
                                -4736348.958775471,
                                4081284.5528982095,
                                "2018-07-19T15:18:30Z",
                                1216369.1229444197,
                                -4736377.467107148,
                                4081240.888485707
                            ]
                        },
                        "orientation": {
                            "unitQuaternion": [
                                0.3084011337938999,
                                0.3210181022701266,
                                -0.45850421987074924,
                                0.7686388857813198
                            ]
                        }
                    },
                    {
                        "id": "Polyline",
                        "polyline": {
                            "positions": {
                                "cartesian": [
                                    1216348.1632364073,
                                    -4736348.958775471,
                                    4081284.5528982095,
                                    1216369.1229444197,
                                    -4736377.467107148,
                                    4081240.888485707
                                ]
                            },
                            "material": {
                                "polylineOutline": {
                                    "color": {
                                        "rgba": [255, 255, 0, 255]
                                    },
                                    "outlineColor": {
                                        "rgba": [0, 0, 0, 255]
                                    },
                                    "outlineWidth": 2
                                }
                            },
                            "width": 10,
                            "clampToGround": true
                        }
                    }
                ];

                let dataSourcePromise = Cesium.CzmlDataSource.load(czml);
                viewer.dataSources.add(dataSourcePromise);
                // viewer.zoomTo(dataSourcePromise);
            }
        }
    }
</script>

<style scoped>
    #csContainer {
        height: 100%;
    }
</style>
